<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <!-- .title -->
            <b-col lg="12">
              <b-form-group
                id="input-group-1"
                :label="$t('polls.title')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="input-1"
                    v-model="newItem.title"
                    type="text"
                    :placeholder="$t('polls.title')"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- .description --> </b-col
            ><b-col lg="12">
              <b-form-group
                id="input-group-2"
                :label="$t('badges.description')"
                label-for="input-2"
              >
                <ckeditor :config="{ contentsLangDirection : 'rtl',versionCheck : false}" 
                  id="textarea-2"
                  v-model="newItem.description"
                  :placeholder="$t('polls.description')"
                  rows="8"
                />
              </b-form-group>
              <!-- .user -->
            </b-col>
            <b-col lg="12">
              <select-target ref="target" />
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-6"
                label="خلال الفترة الزمنية"
                label-for="input-6"
              >
                <validation-provider
                  #default="{ errors }"
                  name="rangeDate"
                  vid="rangeDate"
                  rules="required"
                >
                  <flat-pickr
                    v-model="rangeDate"
                    class="form-control"
                    :config="config"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- .expiry_date -->
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
               
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
              >
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()"  variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "../../../../Controllers/PollsController";
import config from "../../../../config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import SelectTarget from "./SelectTarget.vue";
var dates = [];
import flatPickr from "vue-flatpickr-component";
import { Arabic } from "flatpickr/dist/l10n/ar.js";
const controller = new Controller();
export default {
  name: "PollsForm",
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    SelectTarget,
    flatPickr,
  },
  props: ["newItem"],
  data() {
    return {
      file: {},
      
      user: [],
      edu_program: [],
      room: [],
      config: {
        mode: "range",
        minDate: "today",
        dateFormat: "Y-m-d",
        locale: Arabic,

        onChange: function (date) {
          if (date.length == 2) {
            dates = date;
            // interact with selected dates here
          }
        },
      },
    };
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      let target = this.$refs.target.getData();
      this.newItem.target = target.target;
      this.newItem.room = target.room;
      this.newItem.edu_program = target.edu_program;
      this.newItem.edu_course = target.edu_course;
      this.newItem.publish_date = dates[0]
        .toJSON()
        .slice(0, 19)
        .replace("T", " ");
      this.newItem.expiry_date = dates[1]
        .toJSON()
        .slice(0, 19)
        .replace("T", " ");
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
